export enum InputTypes {
  TextArea = 'textarea',
  Text = 'text',
  Password = 'password'
}
